module.exports = __webpack_public_path__ + "img/chart.b9f49d64.svg";